import React from "react";
import { Icons, Tag } from "@pankod/refine-antd";

import { getActionMetadata } from "../utils/audit-log.helpers";

type AuditActionTagProps = {
  action?: string | null;
};

export const AuditActionTag: React.FC<AuditActionTagProps> = ({ action }) => {
  const metadata = getActionMetadata(action);

  return (
    <Tag className={metadata.className} color={metadata.color}>
      <Icons.EditOutlined />
      <span>{metadata.label}</span>
    </Tag>
  );
};